import { render, staticRenderFns } from "./extraProductBox.vue?vue&type=template&id=5d984b0a&scoped=true"
import script from "./extraProductBox.vue?vue&type=script&lang=js"
export * from "./extraProductBox.vue?vue&type=script&lang=js"
import style0 from "./extraProductBox.vue?vue&type=style&index=0&id=5d984b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d984b0a",
  null
  
)

export default component.exports